const strings = {
  labels: {
    header: 'Locations',
    nameColumn: 'Location Name',
    addressColumn: 'Address',
  },
  placeholders: {
    search: 'Search by location',
  },
} as const;

export default strings;
